import { render, staticRenderFns } from "./BriefcaseFolderSelect.vue?vue&type=template&id=2deebe40&scoped=true"
import script from "./BriefcaseFolderSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./BriefcaseFolderSelect.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BriefcaseFolderSelect.vue?vue&type=style&index=0&id=2deebe40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deebe40",
  null
  
)

export default component.exports